export default "__VITE_ASSET__hcm5WrkE__"